const checkboxButtonSize = 24;
const checkboxButtonLabelGap = 8;

const CheckboxTheme = {
  baseStyle: {
    container: {
      ':hover > span:first-of-type': {
        borderColor: 'neutral.70',
      },
      _disabled: {
        ':hover > span:first-of-type': {
          borderColor: 'neutral.90',
        },
        cursor: 'not-allowed',
      },
      alignItems: 'flex-start',
    },
    control: {
      _checked: {
        _disabled: {
          backgroundColor: 'neutral.80',
        },
        backgroundColor: 'purple.50',
      },
      _disabled: {
        backgroundColor: 'neutral.93',
        borderColor: 'neutral.90',
        cursor: 'not-allowed',
      },
      _focus: {
        boxShadow: 'formFocus',
      },
      _focusVisible: {
        boxShadow: 'formFocus',
      },
      _hover: {
        borderColor: 'neutral.70',
      },
      border: '1px solid',
      borderColor: 'neutral.90',
      borderRadius: '4',
      boxShadow: 'inner',
      height: '24',
      transitionDuration: '200ms',
      width: '24',
    },
    icon: {
      color: 'neutral.100',
    },
    label: {
      _disabled: { color: 'neutral.60' },
      alignItems: 'center',
      display: 'flex',
      gap: '4',
      marginLeft: -checkboxButtonSize,
      paddingLeft: checkboxButtonSize + checkboxButtonLabelGap,
      userSelect: 'none',
    },
  },
};

export default CheckboxTheme;
